import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject, Observable } from 'rxjs';
import { GetDefaultCurrency$Params } from 'src/api/generated/fn/menu/get-default-currency';
import { GetDefaultCurrency_1$Params } from 'src/api/generated/fn/venue/get-default-currency-1';
import { MenuCurrencyDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Menu/menu-currency-dto';
import { MenuService, VenueService } from 'src/api/generated/services';
import { RoleNameEnum } from 'src/app/admin-panel/enums/role-name.enum';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  private currencyValue = new BehaviorSubject<MenuCurrencyDto | null | undefined>(undefined);
  private readonly access_token = 'pos_access_token';

  get token(): any {
    return localStorage.getItem(this.access_token);
  }

  constructor(private venueService: VenueService,
              private menuService: MenuService,
              private _jwtHelperService: JwtHelperService) { 
        const tokenDecoded = this._jwtHelperService.decodeToken(this.token);
        const companyId = tokenDecoded.cmid;
        if(tokenDecoded.rlnm.includes(RoleNameEnum.PosManager)){
          const params: GetDefaultCurrency_1$Params = { CompanyId: companyId };
          this.venueService.getDefaultCurrency_1(params).subscribe((currency: MenuCurrencyDto) => {this.currencyValue.next(currency);})
        }else{
          const params: GetDefaultCurrency$Params = { CompanyId: companyId };
          this.menuService.getDefaultCurrency(params).subscribe((currency: any) => this.currencyValue.next(JSON.parse(currency)))
        }
  }

  public currencyObservable(): Observable<any | null | undefined> {
    return this.currencyValue.asObservable();
  }

  public resetCurrency(): void {
    this.currencyValue.next(null);
  }
}
